import React from "react";
import Globals from "../../api";
import ReactHtmlParser from "react-html-parser";

export default class commonPages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      commonContents: [],
    };
  }

  componentDidMount() {
    const commonPageData = Globals.common_contents;
    fetch(commonPageData)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          commonContents: data.FooterLinks.Items,
        });
      });
  }

  render() {
    let ContactHtml = '<div class="container m-b-20 contactus_page"> <div class="page_title"> <h1>எங்களை தொடர்பு கொள்ள - </h1> </div><h4>Thank You for visiting our site. We value our users and would be happy to hear from you. Please connect with us in case of any queries, concerns or for any kind of feedbacks.</h4> <div class="contact_us_block1"> <p>वவெப்துனியாவில் வெளியிடப்பட்ட எந்த செய்தி அல்லது கட்டுரையாக இருப்பினும் அல்லது எந்த ஒரு தகவலை அறியவும் நீங்கள் <a href="/cdn-cgi/l/email-protection#9cf9f8f5e8f3eef5fdf0dcebf9fef8e9f2f5fdb2f2f9e8" title="email"> <span class="__cf_email__" data-cfemail="0f6a6b667b607d666e634f786a6d6b7a61666e21616a7b">[email&#160;protected]</span> </a> என்ற மின்னஞ்சல் முகவரிக்கு மின்னஞ்சல் செய்யலாம். அல்லது கீழ் கண்ட முகவரிக்கு எழுதலாம்: </p><hr/> <p>For any Content published on Webdunia.com or to get any information you can email to us on <a href="/cdn-cgi/l/email-protection" class="__cf_email__" data-cfemail="afcacbc6dbc0ddc6cec3efd8cacdcbdac1c6ce81c1cadb">[email&#160;protected]</a> or You can also write to us : </p></div><div class="contact_us_block2"> <p>"संपादकीय विभाग" वेबदुनिया.कॉम (इंडिया) प्रा. लि. "लाभ-गंगा", 582 महात्मा गांधी मार्ग, इंदौर - 452003 [भारत]</p><p><b>दूरभाष :</b>+91-731-4273409 | <b>फैक्स :</b>+91-731-254-8555</p><hr/> <p>Webdunia.com (India) Pvt Ltd (CMMI 3) "Labh Ganga", 582 MG Road, Indore - 452003 MP [India] </p><p><b>Contact :</b>+91-731-4273409 | <b>Fax :</b>+91-731-254-8555</p></div><div class="clearfix"></div><p><b>உரிமை துறப்பு:</b>: தயவுச்செய்து திட்டுவது, கொச்சைப்படுத்துவது, அசிங்கமான, பெருமை குலைக்கும், சட்டச் சிக்கலான, சட்டத்திற்குப் புறம்பான, எதிர்மறையான விளைவுகளை ஏற்படுத்தக்கூடிய, சர்ச்சையான, தரக்குறைவான கருத்துக்களை இடவேண்டாம். அதுபோன்ற பொருளடக்கங்களை பயனாளர்கள்/வாசகர்கள் இட்டால் அதனை நீக்கும் உரிமை வெப்துனியா.காம் நிறுவன நிர்வாகத்திற்கு உள்ளது. </p><p><b>Disclaimer</b>: Kindly do not post any defamatory, infringing, obscene, indecent, discriminatory or unlawful material or information. Webdunia.com (India) Pvt Ltd reserves the right to remove any content received from users/readers without notice.</p><p><b>To advertise on Webdunia network sites/app, click <a href="/advertise-with-us">Advertise with Us</a> </b></p><p><b>To know more about Webdunia , click <a href="/about-us">About Us</a></b></p></div>';
    let url = window.location.pathname;

    
    let pageContents = this.state.commonContents.filter(
      (x) => x.DefaultUrl == `${url}`
    );
    {
      var DataItems = pageContents.map((item) => {
        var htmlContent = item.Pagehtml;
        return ReactHtmlParser(htmlContent);
      });
    }
    if (url == "/contact-us")
    DataItems = ReactHtmlParser(ContactHtml);
      
    return <div className="container padding15">{DataItems}</div>;
  }
}
